import React from 'react';
import './Card.css';
import { useTranslation } from '../i18n';

function Card({ value, isVisible, size = 'normal' }) {
  const { t } = useTranslation();
  const displayValue = value === 'SKIP-BO' ? 'SB' : value;

  // Determine color class based on value
  const getColorClass = () => {
    if (value === 'SKIP-BO') return 'wild-card';
    const numValue = parseInt(value);
    if (numValue >= 1 && numValue <= 4) return 'blue-card';
    if (numValue >= 5 && numValue <= 8) return 'green-card';
    if (numValue >= 9 && numValue <= 12) return 'red-card';
    return '';
  };

  return (
    <div className={`card ${isVisible ? 'visible' : 'hidden'} ${size} ${getColorClass()}`}>
      {isVisible ? (
        <div className="card-content">
          <div className="card-corner card-corner-top">{displayValue}</div>
          <div className="card-value-center">{displayValue}</div>
          <div className="card-corner card-corner-bottom">{displayValue}</div>
          {value === 'SKIP-BO' && <div className="wild-indicator">{t('card.wild')}</div>}
        </div>
      ) : (
        <div className="card-back">
          <div className="card-pattern"></div>
        </div>
      )}
    </div>
  );
}

export default Card;
